/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliSavePeriodGradeDto } from '../../models/amoxcalli-save-period-grade-dto';

export interface ApiGradesPeriodBulkPost$Params {
      body?: Array<AmoxcalliSavePeriodGradeDto>
}

export function apiGradesPeriodBulkPost(http: HttpClient, rootUrl: string, params?: ApiGradesPeriodBulkPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiGradesPeriodBulkPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiGradesPeriodBulkPost.PATH = '/api/grades/period/bulk';
